var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-container"},[_c('Card',{staticClass:"m-card"},[_c('div',[_c('Table',{attrs:{"columns":_vm.NursingQualityControlReporcolumns,"no-data-text":_vm.L('NoDatas'),"border":"","highlight-row":"","data":_vm.NursingQualityControlReporList,"loading":_vm.loading}})],1)])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d43b0ff6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pdQualityControlManage/pdNursingQualityControlRepor/index.vue
// module id = null
// module chunks = 